import Splide from '@splidejs/splide';
import { initProductBuyTile } from '../../../snippets/product-buy-tile-control/product-buy-tile-control';

function mountProductsSlider(el) {
  new Splide(el, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: true,
    gap: 40,
    pagination: true,
    destroy: true,
    classes: {
      pagination:
        'splide__pagination smart-home-control-products__slider-pagination',
      page: 'splide__pagination__page smart-home-control-products__slider-pagination-btn',
    },
    breakpoints: {
      679: {
        destroy: false,
      },
    },
  }).mount();
}

export const initProducts = () => {
  const smartHomeControlProducts = document.querySelectorAll(
    '[data-smart-home-control-product]'
  );

  smartHomeControlProducts.forEach((smartHomeControlProduct) => {
    const smartHomeControlProductId = smartHomeControlProduct.getAttribute(
      'data-smart-home-control-product'
    );

    initProductBuyTile(smartHomeControlProductId);
  });

  const productsSlider = document.querySelector(
    '[data-smart-home-control-products-slider]'
  );

  mountProductsSlider(productsSlider);
};
